import React, { useState } from 'react';
import { Button, Form, Spinner } from 'react-bootstrap';
import { useGetSubjectsQuery } from '../../app/services/subjectApi';
import { useTranslation } from 'react-i18next';
import { Subject } from '../../types';
import HelperTooltip from '../resources/helperTooltip/HelperTooltip';

type Props = {
  value: Subject | undefined;
  onChange: (subject: Subject) => void;
}

const SubjectInput: React.FC<Props> = ({value, onChange}) => {
  
  const { data:subjects, isLoading } = useGetSubjectsQuery();
  const {t:_} = useTranslation();

  const [searchValue, setSearchValue] = useState<string>('');
  const [showOptions, setShowOptions] = useState<boolean>(false);

  const handleInputChange = (newValue: string) => {
    setSearchValue(newValue);
    setShowOptions(!!newValue);
  }

  const handleSubjectSelection = (subject: Subject) => {
    setSearchValue('');
    onChange(subject)
    setShowOptions(false);
  }

  const handleOnBlur = (e: React.FocusEvent) => {
    if (e.relatedTarget === null) {
      setSearchValue('');
      setShowOptions(false);
    }
  }
  
  return (
    <Form.Group>
      <h5>
        <span style={{ color: "red" }}>*</span>&nbsp;
        {_("Subject")}
        <HelperTooltip tooltipText={_("subjectInformation")} />
      </h5>
      <Form.Control
        autoComplete="off"
        name="subject" 
        role="input"
        aria-label="Subject input"
        value={searchValue}
        onBlur={(e: React.FocusEvent<HTMLInputElement>) => handleOnBlur(e)}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleInputChange(e.currentTarget.value)}
        placeholder={
          !!value?.id ? `${value.title?.en} / ${value.title?.cy}` : _('-- start typing and select from the list --')
        } 
        isInvalid={!value}
      />

      { showOptions && (
        <div className='z-1 w-100 rounded' style={{overflowY: 'scroll', maxHeight: '300px'}}>
          { isLoading ? (
            <Spinner animation="border" className="me-3 mb-2" />
          ) : (
            subjects ? (
              subjects.subjects
                .filter((subject: Subject) => (
                  subject.title.en
                    .toLowerCase()
                    .includes(searchValue.toLowerCase()) ||
                  subject.title.cy
                    .toLowerCase()
                    .includes(searchValue.toLowerCase())
                ))
                .map((subject: Subject) => (
                  <Button
                    key={subject.id}
                    onClick={(e) => {e.stopPropagation(); e.preventDefault(); handleSubjectSelection(subject)}}
                    className="w-100 text-start"
                    variant='light'
                  >
                    {subject.title.en} / {subject.title.cy}
                  </Button>
                ))
            ) : (
              <p>{_('Unable to retrieve subject list')}</p>
            )
          )}
        </div>
      )}
    </Form.Group>
  )
}

export default SubjectInput;